import React from 'react';
import { Box, Button } from '@mui/material';

/**
 * 编辑器工具栏组件
 * 包含重置代码等操作按钮
 */
function EditorToolbar({ onResetCode, resetDisabled = false }) {
  return (
    <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', px: 2 }}>
      <Button
        size="small"
        variant="text"
        onClick={onResetCode}
        disabled={resetDisabled}
        sx={{ fontSize: '0.75rem' }}
      >
        Reset to Default
      </Button>
    </Box>
  );
}

export default EditorToolbar;

